import React from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import usePublicOffer
  from "../hooks/usePublicOffer";

import PublicOfferHeader
  from "../components/PublicOfferHeader";

import PublicOfferDetails
  from "../components/PublicOfferDetails";

import PublicOfferItems
  from "../components/PublicOfferItems";

import PublicOfferTotals
  from "../components/PublicOfferTotals";

import PublicOfferActions
  from "../components/PublicOfferActions";

import {
  PUBLIC_OFFER_STATUS,
} from "../constants/publicOffer.constants";


const PublicOfferPage = () => {

  const {
    token,
  } = useParams();


  const navigate =
    useNavigate();


  const {
    publicOffer,
    loading,
    accepting,
    error,
    acceptError,
    acceptOffer,
  } =
    usePublicOffer(
      token
    );


  /*
  |--------------------------------------------------------------------------
  | LOADING
  |--------------------------------------------------------------------------
  */

  if (loading) {

    return (
      <main className="public-offer-page">

        <div className="public-offer-loading">

          <div className="public-offer-spinner" />

          <p>
            Loading offer...
          </p>

        </div>

      </main>
    );

  }


  /*
  |--------------------------------------------------------------------------
  | ERROR
  |--------------------------------------------------------------------------
  */

  if (error) {

    return (
      <main className="public-offer-page">

        <div className="public-offer-error">

          <div className="public-offer-error-icon">
            !
          </div>

          <h1>
            Offer Unavailable
          </h1>

          <p>
            {error}
          </p>

        </div>

      </main>
    );

  }


  /*
  |--------------------------------------------------------------------------
  | NO OFFER
  |--------------------------------------------------------------------------
  */

  if (!publicOffer) {

    return (
      <main className="public-offer-page">

        <div className="public-offer-error">

          <h1>
            Offer Not Found
          </h1>

          <p>
            This public offer could not be found.
          </p>

        </div>

      </main>
    );

  }


  /*
  |--------------------------------------------------------------------------
  | PUBLIC OFFER STATUS
  |--------------------------------------------------------------------------
  */

  const status =
    publicOffer?.publicOffer?.status;


  /*
  |--------------------------------------------------------------------------
  | ACCEPTED
  |--------------------------------------------------------------------------
  |
  | Only navigate to payment after the
  | backend acceptance request succeeds.
  |
  | If the offer is already accepted, allow
  | the customer to continue directly to
  | the payment page.
  |
  */

  const handleAccepted =
    (acceptedOffer) => {

      console.log(
        "Public offer accepted:",
        acceptedOffer
      );


      /*
      |--------------------------------------------------------------------------
      | IMPORTANT
      |--------------------------------------------------------------------------
      |
      | Correct public payment route:
      |
      | /offer/:token/payment
      |
      | NOT:
      |
      | /offer/payment/:token
      |
      */

      navigate(
        `/offer/${token}/payment`,
        {
          replace: true,
        }
      );

    };


  /*
  |--------------------------------------------------------------------------
  | CONTINUE TO PAYMENT
  |--------------------------------------------------------------------------
  |
  | Existing accepted offers can continue
  | directly to payment.
  |
  */

  const handleContinueToPayment =
    () => {

      navigate(
        `/offer/${token}/payment`,
        {
          replace: true,
        }
      );

    };


  /*
  |--------------------------------------------------------------------------
  | RENDER
  |--------------------------------------------------------------------------
  */

  return (

    <main className="public-offer-page">

      <div className="public-offer-container">

        <PublicOfferHeader
          publicOffer={
            publicOffer
          }
        />


        <PublicOfferDetails
          publicOffer={
            publicOffer
          }
        />


        <PublicOfferItems
          publicOffer={
            publicOffer
          }
        />


        <PublicOfferTotals
          publicOffer={
            publicOffer
          }
        />


        {acceptError && (

          <div
            className="public-offer-alert error"
          >
            {acceptError}
          </div>

        )}


        {status ===
          PUBLIC_OFFER_STATUS.ACCEPTED ? (

          <section className="public-offer-actions accepted">

            <div className="public-offer-action-icon">
              ✓
            </div>

            <div>

              <h3>
                Offer Accepted
              </h3>

              <p>
                This offer has already
                been accepted.
              </p>

            </div>

            <button
              type="button"
              className="public-offer-primary-button"
              onClick={
                handleContinueToPayment
              }
            >
              Continue to Payment
            </button>

          </section>

        ) : (

          status !==
            PUBLIC_OFFER_STATUS.EXPIRED &&
          status !==
            PUBLIC_OFFER_STATUS.REVOKED && (

            <PublicOfferActions

              publicOffer={
                publicOffer
              }

              accepting={
                accepting
              }

              acceptOffer={
                acceptOffer
              }

              onAccepted={
                handleAccepted
              }

            />

          )

        )}

      </div>

    </main>

  );

};


export default PublicOfferPage;
